export const isMediaField = (field) => ['video', 'audio'].includes(field?.field_type)

export const isImageField = (field) => field?.field_type === 'image'
